import "./App.css";
import { getMovieList, searchMovie } from "./api";
import { useEffect, useState } from "react";

const App = () => {
  const [popularMovies, setPopularMovies] = useState([]);
  const [sortOrder, setSortOrder] = useState("desc"); // State untuk urutan vote_average
  const [sortType, setSortType] = useState("vote_average"); // State untuk jenis pengurutan
  useEffect(() => {
    getMovieList().then((result) => {
      setPopularMovies(result);
    });
  }, []);

  const sortMovies = () => {
    const sortedMovies = [...popularMovies];
    sortedMovies.sort((a, b) => {
      if (sortType === "vote_average") {
        return sortOrder === "asc"
          ? a.vote_average - b.vote_average
          : b.vote_average - a.vote_average;
      } else if (sortType === "release_date") {
        return sortOrder === "asc"
          ? new Date(a.release_date) - new Date(b.release_date)
          : new Date(b.release_date) - new Date(a.release_date);
      }
      return 0;
    });
    setPopularMovies(sortedMovies);
  };

  const toggleSortOrder = () => {
    setSortOrder((prevOrder) => (prevOrder === "asc" ? "desc" : "asc"));
  };

  const toggleSortType = (type) => {
    setSortType(type);
  };

  const PopularMovieList = () => {
    return popularMovies.map((movie, i) => {
      return (
        <div className="rounded-md lazy relative overflow-hidden" key={i}>
          <div className="px-1 rounded-tl-md rounded-br-md bg-black bg-opacity-70 absolute top-0 start-0">
            {movie.release_date}
          </div>
          <div className="px-1 rounded-tr-md rounded-bl-md bg-amber-400 absolute top-0 end-0">
            {movie.vote_average}
          </div>
          <img
            className="w-full rounded-md"
            alt="..."
            src={`${process.env.REACT_APP_BASEIMGURL}/${movie.poster_path}`}
          />
          <div className="bg-opacity-70 rounded-b-md w-full h-10 sm:h-16 md:14 flex bottom-0 bg-black absolute items-center justify-center">
            <p className="line-clamp-2">{movie.title}</p>
          </div>
        </div>
      );
    });
  };

  const search = async (q) => {
    if (q.length > 0) {
      const Query = await searchMovie(q);
      setPopularMovies(Query.results);
    }
  };

  return (
    <div className="App bg-slate-800 flex justify-center w-screen h-full">
      <header className="App-header w-full md:w-3/4 mx-4 sm:mx-10 md:mx-12 pt-8">
        <p className="text-3xl font-bold">FIGURAN04 MOVIE</p>
        <div className="flex justify-center items-center mt-4">
          <input
            placeholder="Cari"
            className="text-black text-md h-8 md:h-10 w-100 px-2 rounded-md"
            onChange={({ target }) => search(target.value)}
          />
          <button
            className="ml-2 px-2 py-2 rounded-md bg-gray-700 text-white"
            onClick={() => {
              toggleSortType("vote_average");
              toggleSortOrder();
              sortMovies();
            }}
          >
            Rating {sortOrder === "asc" ? "^" : "v"}
          </button>
          <button
            className="ml-2 px-2 py-2 rounded-md bg-gray-700 text-white"
            onClick={() => {
              toggleSortType("release_date");
              toggleSortOrder();
              sortMovies();
            }}
          >
            Date {sortOrder === "asc" ? "^" : "v"}
          </button>
        </div>
        <div className="Movie-container gap-2 w-full grid grid-cols-3 sm:grid-cols-4 md:grid-cols-4 py-3">
          <PopularMovieList />
        </div>
      </header>
    </div>
  );
};

export default App;
